export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "name",
          name: t('menu_form_name'),
          type: "text",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "description",
          name: t('menu_form_description'),
          type: "text",
          required: false,
          defaultValue: "",
          size: "small"
        },
        /* {
          id: "branch_office",
          name: t('menu_form_branch_office'),
          type: "select",
          containerOptions: "branch_offices",
          required: true,
          defaultValue: "",
          size: "small"
        }, */
        {
          id: "google_analytics",
          name: t('menu_form_google_analytics'),
          type: "codeeditor",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "facebook_pixel",
          name: t('menu_form_facebook_pixel'),
          type: "codeeditor",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "active",
          name: t('menu_form_active'),
          type: "switch",
          required: true,
          defaultValue: false,
          size: "small"
        },
      ]
    }
  ]
}